import React from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";

import { Avatar } from "@shared/components/Avatar";
import { UserInfoProps } from "../types";

export const UserInfo: React.FC<UserInfoProps> = ({
  user,
  mode,
  currentLocale,
  onToggleMode,
  onClickLanguageMenu,
}) => {
  return (
    <Stack direction="row" gap={2} alignItems="center" justifyContent="center">
      {/* <IconButton
        color="inherit"
        onClick={onClickLanguageMenu}
        aria-controls="language-menu"
        aria-haspopup="true"
      >
        <Avatar
          src={`/images/flags/${currentLocale}.png`}
          sx={{ width: 28, height: 28 }}
        />
      </IconButton> */}

      <IconButton color="inherit" onClick={onToggleMode}>
        {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
      </IconButton>

      {user?.full_name && (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar src={user.image as string} name={user.full_name} size={32} />

          <Typography style={{ textAlign: "center" }}>
            {user.full_name}
          </Typography>
        </div>
      )}
    </Stack>
  );
};
